<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ButtonAllNotReadonly from '../UI/Button/ButtonAllNotReadonly.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import Loader from '../UI/Loading/Loader.vue'
import { LEGAL_PERSON, NATURAL_PERSON } from '../../Constants/LegalEntityType'

export default {
  components: { Loader, FormCreator, ModalDialog, ButtonAll, ButtonAllNotReadonly },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    context: {
      type: [String, Number],
      default: 'idClient',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    add: {
      type: Boolean,
      required: false,
      default: true,
    },
    id: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  emits: ['submitted'],

  data: () => ({
    entity: { id: null },
    def: {},
    defNaturalPerson: {},
    loadField: false,
    loadInfoFields: true,
    loadForm: false,
    params: {},
    sending: false,
    formData: {},
  }),

  computed: {
    entityAddressFieldsView() {
      const fields = ['address.siret', 'address.address', 'address.postalCode', 'address.city', 'address.countryCode']

      return fields.filter((field) => !this.isFieldDisabled(field))
    },
    entityInformationFields() {
      let fields = []
      if (this.entity.legalEntityType === LEGAL_PERSON) {
        fields = [
          'name',
          'inFormation',
          'siren',
          'createdAt',
          'workforce',
          'rcs',
          'vatIntra',
          'activity',
          'activityDesc',
          'capital',
          'legalForm',
          'legalFormCode',
        ]
      } else {
        fields = ['imageFile', 'name', 'identificationNumber', 'createdAt', 'activityDesc']
      }

      return fields.filter((field) => !this.isFieldDisabled(field))
    },
    platformId() {
      return user?.entity?.id ?? config.platformId
    },
    disabledFields() {
      const inFormation = this.entity.inFormation
      const inFormationOrNaturalPerson = inFormation || this.entity.legalEntityType === NATURAL_PERSON
      const fields = [
        { field: 'siren', disabled: inFormationOrNaturalPerson },
        { field: 'createdAt', disabled: inFormationOrNaturalPerson },
        { field: 'workforce', disabled: inFormationOrNaturalPerson },
        { field: 'rcs', disabled: inFormationOrNaturalPerson },
        { field: 'vatIntra', disabled: inFormationOrNaturalPerson },
        { field: 'activity', disabled: inFormationOrNaturalPerson },
        { field: 'activityDesc', disabled: inFormationOrNaturalPerson },
        { field: 'capital', disabled: inFormationOrNaturalPerson },
        { field: 'legalForm', disabled: inFormationOrNaturalPerson },
        { field: 'legalFormCode', disabled: inFormationOrNaturalPerson },
        { field: 'address.siret', disabled: inFormationOrNaturalPerson },
      ]

      return fields.filter(({ disabled }) => disabled).map(({ field }) => field)
    },
    legalEntityView() {
      return this.entity.legalEntityType === LEGAL_PERSON
    },
  },
  watch: {
    disabledFields: {
      handler(fields) {
        if (fields.length > 0) {
          for (const disabledField of this.disabledFields) {
            this.$refs.entityForm.datasToRemove[disabledField] = true
          }
        } else {
          this.$refs.entityForm?.emptyObject(this.$refs.entityForm.datasToRemove)
        }
      },
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ build, object, def }) {
      this.loadField = build

      this.def = def
      this.entity = object

      if (build) {
        this.openModal()
      }
    },
    setParams(extraParams = {}) {
      this.params = {
        platformId: this.platformId,
        ...extraParams,
      }
    },
    showForm(id) {
      this.entity.id = id

      let extraParams = {}
      if (!!id) {
        extraParams.id = id
      }

      this.setParams(extraParams)
      this.openModal()
    },
    openModal() {
      this.loadForm = true
      this.sending = false
      this.$refs.entityModal.open()
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs.entityModal.close(false)
    },
    isSending(bool) {
      this.sending = bool
    },
    objectReturn({ sending, object, context }) {
      this.sending = sending

      if (object) {
        this.entity = object
        this.$emit('submitted', object)

        if (!this.legalEntityView || context === 'patch' || this.entity.inFormation) {
          this.closeModal()
        }
      }
    },
    create(context) {
      this.sending = true
      this.$refs.entityForm.params = this.params
      this.$refs.entityForm.methods(context)
    },
    setEntityCountry(val) {
      this.entity.countryCode = val

      if (val !== 'ES') {
        this.entity.legalEntityType = LEGAL_PERSON
      }
    },
    async setLegalEntityType(val) {
      this.loadInfoFields = false
      await this.delay(500) // force to delay for refresh all select (especially for datetimepicker)
      this.entity.legalEntityType = val
      this.loadInfoFields = true
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    onInputChange(fieldName, event) {
      if (fieldName === 'inFormation') {
        this.entity.inFormation = event === false // $event is false when checked and true otherwise 🤷
      }
    },
    isFieldDisabled(fieldName) {
      return this.disabledFields.includes(fieldName)
    },
    getSpecificLabel(fieldName) {
      if (fieldName === 'name' && this.entity.legalEntityType === NATURAL_PERSON) {
        return `entity.fields.naturalName.label`
      }

      return `entity.fields.${fieldName}.label`
    },
  },
}
</script>
<template>
  <div :id="'page-entity' + context" class="h-100">
    <div v-if="hasRole('ROLE_ADVANCE_ENTITY_CREATE')" class="btn-group h-100">
      <ButtonAllNotReadonly
        v-if="add"
        ref="addEntity"
        margin="no"
        type="add"
        icon="add"
        size="small"
        :label="small ? '' : 'entity.modal.add_button'"
        width="aligned"
        e2e-button="addEntity"
        @click="showForm()"
      />
      <ButtonAllNotReadonly
        v-if="!!id"
        ref="entityId"
        margin="no"
        type="add"
        icon="modify"
        size="small"
        :label="small ? '' : 'entity.modal.edit_button'"
        width="aligned"
        e2e-button="updateEntity"
        @click="showForm(id)"
      />
    </div>
    <ModalDialog
      :id="'entity' + context"
      ref="entityModal"
      :title="entity.id ? $t('entity.modal.edit_title') : $t('entity.modal.add_title')"
      :id-modal-page="'page-entity' + context"
      class-modal-dialog="modal-xl"
      multiple
      e2e-modal="entity"
      @icon-close="closeModal"
    >
      <template #body>
        <FormCreator
          v-if="loadForm"
          :id="entity.id"
          ref="entityForm"
          endpoint="entities"
          :params="params"
          specific-endpoint="create"
          send-params
          class-to-add="d-none"
          in-modal
          @update-data="updateData"
          @global-build="globalBuild"
          @object-return="objectReturn"
          @is-sending="isSending"
        />

        <div class="row">
          <div class="col-md-4">
            <h4>{{ $t('entity.modal.general') }}</h4>
            <template v-if="loadField">
              <field-creator
                :form-data="formData"
                name="countryCode"
                form-ref="entityForm"
                domain="entity"
                label-top
                type-value="string"
                @get-select-change="setEntityCountry"
              />
              <field-creator
                :form-data="formData"
                name="legalEntityType"
                form-ref="entityForm"
                domain="entity"
                label-top
                type-value="string"
                @get-select-change="setLegalEntityType"
              />
              <field-creator
                v-if="entity.id && legalEntityView && !entity.inFormation"
                :form-data="formData"
                name="director"
                form-ref="entityForm"
                domain="entity"
                label-top
                add-director
                :entity-id="entity.id"
              />
              <field-creator
                v-if="entity.id && legalEntityView && !entity.inFormation"
                :form-data="formData"
                name="signer"
                form-ref="entityForm"
                domain="entity"
                label-top
                add-user
                :entity-id="entity.id"
              />
              <field-creator
                v-if="entity.id"
                :form-data="formData"
                name="disputeType"
                form-ref="entityForm"
                domain="entity"
                label-top
              />
              <div v-for="(formField, fieldName) in def.formFields" :key="fieldName">
                <field-creator
                  v-if="entity.id"
                  :form-data="formData"
                  :name="'formFields.' + fieldName"
                  form-ref="entityForm"
                  domain="entity"
                  label-top
                  dynamic-label
                  dynamic-form
                  multiple-choice
                  :placeholder-config="false"
                />
              </div>
            </template>
            <Loader v-else></Loader>
          </div>
          <div class="col-md-4 border-information">
            <h4>{{ $t('entity.modal.informations') }}</h4>
            <template v-if="loadField && loadInfoFields">
              <div v-for="fieldName of entityInformationFields" :key="fieldName">
                <field-creator
                  :form-data="formData"
                  :name="fieldName"
                  :type-value="fieldName === 'siren' ? 'string' : 'int'"
                  :label="getSpecificLabel(fieldName)"
                  form-ref="entityForm"
                  domain="entity"
                  label-top
                  @get-input-change="onInputChange(fieldName, $event)"
                />
              </div>
            </template>
            <Loader v-else></Loader>
          </div>
          <div class="col-md-4">
            <h4>{{ $t('entity.modal.address') }}</h4>
            <template v-if="loadField">
              <div v-for="fieldName of entityAddressFieldsView" :key="fieldName">
                <field-creator
                  :form-data="formData"
                  :name="fieldName"
                  form-ref="entityForm"
                  domain="entity"
                  label-top
                  type-value="string"
                />
              </div>
            </template>
            <Loader v-else></Loader>
          </div>
        </div>
      </template>
      <template #footer>
        <ButtonAll margin="no" type="information" label="button.cancel" e2e-button="close" @click="closeModal" />
        <ButtonAll
          margin="no"
          type="validation"
          :loading="sending"
          e2e-button="validate"
          label="button.validate"
          @click="create(entity.id === null ? 'post' : 'patch')"
        />
      </template>
    </ModalDialog>
  </div>
</template>
